import { render, staticRenderFns } from "./DragDropList.vue?vue&type=template&id=5bf50b1f&scoped=true&"
import script from "./DragDropList.vue?vue&type=script&lang=js&"
export * from "./DragDropList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf50b1f",
  null
  
)

export default component.exports